// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Atoms-GatsbyLink-module--cls1--36L-Q","cls2":"Atoms-GatsbyLink-module--cls2--2TJzC Atoms-GatsbyLink-module--cls1--36L-Q"};